<template lang="pug">
  CommonLoadBox(:loaded="loaded")
    template(slot='skeleton')
      .exchange-list-skeleton-area
        ExchangeListSkeleton
    template(slot='module')
      ExchangeList(
        :bounty="bounty"
        :points="points"
        :tabs="tabs"
        :popupSource=1
        :moduleConfig="moduleConfig"
        @bounty="handleBounty"
        @loaded="handleLoaded"
        @earnPoints="handleAnchorModule"
      )
</template>

<script>
import eventBus from '@/const/eventBus';
import CommonLoadBox from '@/components/common-load-box';
import ExchangeListSkeleton from '../../skeleton-cpns/exchange-list-skeleton';
import ExchangeList from './exchange-list';
import { TABS } from '../../consts';
import { anchorToModule } from '../../common/helper';

export default {
  name: 'ExchangeModule',
  components: {
    CommonLoadBox,
    ExchangeListSkeleton,
    ExchangeList,
  },
  props: {
    bounty: {
      type: Number,
      default: 0,
    },
    points: {
      type: Number,
      required: true,
    },
    tab: {
      type: Number,
      default: null,
    },
    // 模块数据
    moduleData: {
      type: Array,
      default: () => [],
    },
    rewardGuidingRules: {
      type: Array,
      default: () => [],
    },
    moduleConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 是否加载完成
      loaded: false,
      // 商品tabs
      tabs: TABS,
      // 锚点定时器
      anchorTimer: null,
      // 兑换引导信息
      guideInfo: {},
    };
  },
  created() {
    if (this.moduleData && this.moduleData.length > 0) {
      this.tabs = this.moduleData;
    }
    // 监听从明细页返回的锚定事件
    eventBus.$on('earnPointsAnchor', () => {
      this.handleAnchorModule();
    });
  },
  beforeDestroy() {
    eventBus.$off('earnPointsAnchor');
  },
  methods: {
    // 处理奖励金更新
    handleBounty() {
      this.$emit('bounty');
    },
    // 处理加载完成
    handleLoaded() {
      this.loaded = true;
    },
    // 锚点模块
    handleAnchorModule(num) {
      this.guideInfo = this.getGuideInfo(num || this.points);
      this.anchorTimer = anchorToModule(this.guideInfo, this.anchorTimer);
    },
    // 根据积分匹配引导规则
    getGuideInfo(num) {
      return this.rewardGuidingRules.find((item) => {
        if (item.maxNumber === -1) {
          return item.minNumber <= num;
        }
        return item.minNumber <= num && num <= item.maxNumber;
      }) || {};
    },
  },
};
</script>

<style lang="less" scoped>
.exchange-list-skeleton-area {
  margin-top: 0.12rem;
}
</style>
